import {Color} from '@benchling/nucleus-ui';

import {AntibodyDomainType} from 'graphql-client/__generated/graphqlGlobalTypes';

export const CONNECTOR_DOMAIN_COLOR = Color.BLACK;

export const DEEMPHASIZED_DOMAIN_OPACITY = 0.4;

interface ColorsForChain {
  chainColor: string;
  variableDomainColor: string;
  constantDomainColor: string;
}

export const CONSTANT_DOMAIN_LABEL_COLOR = Color.GRAY_900;
export const VARIABLE_DOMAIN_LABEL_COLOR = Color.WHITE;

export const COLORS_BY_CHAIN_INDEX: Array<ColorsForChain> = [
  {
    chainColor: '#007FB5',
    variableDomainColor: '#005B82',
    constantDomainColor: '#C2EAFB',
  },
  {
    chainColor: '#8DB800',
    variableDomainColor: '#5F7B00',
    constantDomainColor: '#EAFDAA',
  },
  {
    chainColor: '#9E4C2B',
    variableDomainColor: '#6A2E1C',
    constantDomainColor: '#E9C7B8',
  },
  {
    chainColor: '#B5006D',
    variableDomainColor: '#82004E',
    constantDomainColor: '#FBC2E4',
  },
  {
    chainColor: '#00823D',
    variableDomainColor: '#005126',
    constantDomainColor: '#C2FBDD',
  },
  {
    chainColor: '#CA7D49',
    variableDomainColor: '#98582C',
    constantDomainColor: '#C2A693',
  },
  {
    chainColor: '#9A4BD7',
    variableDomainColor: '#6500B5',
    constantDomainColor: '#E2C2FB',
  },
  {
    chainColor: '#368F8B',
    variableDomainColor: '#106965',
    constantDomainColor: '#5CB5B1',
  },
  {
    chainColor: '#CD6672',
    variableDomainColor: '#B23A48',
    constantDomainColor: '#D89CA3',
  },
  {
    chainColor: '#624686',
    variableDomainColor: '#3D2C54',
    constantDomainColor: '#ABA4B8',
  },
  {
    chainColor: '#4F6A89',
    variableDomainColor: '#2E3F55',
    constantDomainColor: '#CCD9E8',
  },
  {
    chainColor: '#BB3E03',
    variableDomainColor: '#9C3402',
    constantDomainColor: '#DD9E81',
  },
];

export const FRIENDLY_NAMES_BY_DOMAIN_TYPE: Record<AntibodyDomainType, string> = {
  [AntibodyDomainType.VL]: 'VL',
  [AntibodyDomainType.CL]: 'CL',
  [AntibodyDomainType.VH]: 'VH',
  [AntibodyDomainType.VHH]: 'VHH',
  [AntibodyDomainType.CH1]: 'CH1',
  [AntibodyDomainType.CH2]: 'CH2',
  [AntibodyDomainType.CH3]: 'CH3',
  [AntibodyDomainType.CH4]: 'CH4',
  [AntibodyDomainType.J]: 'J',
  [AntibodyDomainType.H]: 'Hinge',
  [AntibodyDomainType.L]: 'Linker',
  [AntibodyDomainType.VA]: 'VA',
  [AntibodyDomainType.CA]: 'CA',
  [AntibodyDomainType.VB]: 'VB',
  [AntibodyDomainType.CB]: 'CB',
  [AntibodyDomainType.VG]: 'VG',
  [AntibodyDomainType.CG]: 'CG',
  [AntibodyDomainType.VD]: 'VD',
  [AntibodyDomainType.CD]: 'CD',
  [AntibodyDomainType.F]: 'Fusion',
};

export const ANTIBODY_CONSTANT_DOMAIN_TYPES = [
  AntibodyDomainType.CA,
  AntibodyDomainType.CB,
  AntibodyDomainType.CD,
  AntibodyDomainType.CG,
  AntibodyDomainType.CH1,
  AntibodyDomainType.CH2,
  AntibodyDomainType.CH3,
  AntibodyDomainType.CH4,
  AntibodyDomainType.CL,
  AntibodyDomainType.H,
  AntibodyDomainType.J,
  AntibodyDomainType.L,
];

export enum AntibodyComponentType {
  AA_DOMAIN = 'AA_DOMAIN',
  DNA_DOMAIN = 'DNA_DOMAIN',
  AA_CHAIN = 'AA_CHAIN',
  DNA_CHAIN = 'DNA_CHAIN',
  AA_PAIR = 'AA_PAIR',
  DNA_PAIR = 'DNA_PAIR',
  ANTIGEN = 'ANTIGEN',
}
